import BaseCrud from "@/classes/metadmin/metadmin_listagem";
import Swal from "sweetalert2";
export default class extends BaseCrud {
  constructor(module, lista, params, othis) {
    super(module, lista, params, othis);
  }

    acaoBaixaEstudo(id, row) {
        return {
            name: (id, row) => {
                return "Baixar Estudo";
            },
            action: (id, row)  =>  {
                window.open(global.config.endpoint+`/admin/content/arquivo/${row.custom_link_pdf}`, '_blank')
            },
            html: (id, row) => null,
        };
    }
}